const messages = {
  es: {
    translations: {
      signup: {
        title: "Registro",
        toasts: {
          success:
            "¡El usuario ha sido creado satisfactoriamente! ¡Ahora inicia sesión!",
          fail: "Error creando el usuario. Verifica la data reportada.",
        },
        form: {
          name: "Nombre",
          email: "Correo Electrónico",
          password: "Contraseña",
        },
        buttons: {
          submit: "Regístrate",
          login: "¿Ya tienes una cuenta? ¡Inicia sesión!",
        },
      },
      login: {
        title: "Inicio de Sesión",
        form: {
          email: "Correo Electrónico",
          password: "Contraseña",
        },
        buttons: {
          submit: "Ingresa",
          register: "¿No tienes cuenta? ¡Regístrate!",
        },
      },
      auth: {
        toasts: {
          success: "¡Inicio de sesión exitoso!",
        },
      },
      dashboard: {
        loggedAs: "Conectado como",
        roleAdmin: "Administrador",
        roleUser: "Agente",
        roleSuper: "Super admin",
        teamBoardTitle: "Atenciones del equipo",
        charts: {
          perDay: {
            title: "Tickets hoy: ",
          },
        },
        messages: {
          inAttendance: {
            title: "En servicio"
          },
          waiting: {
            title: "Esperando"
          },
          closed: {
            title: "Finalizado"
          }
        }
      },
      connections: {
        title: "Conexiones",
        toasts: {
          deleted:
            "¡La conexión de WhatsApp ha sido borrada satisfactoriamente!",
        },
        confirmationModal: {
          deleteTitle: "Borrar",
          deleteMessage: "¿Estás seguro? Este proceso no puede ser revertido.",
          disconnectTitle: "Desconectar",
          disconnectMessage: "Estás seguro? Deberá volver a leer el código QR",
        },
        buttons: {
          add: "Agrega WhatsApp",
          disconnect: "Desconectar",
          tryAgain: "Inténtalo de nuevo",
          qrcode: "QR CODE",
          newQr: "Nuevo QR CODE",
          connecting: "Conectando",
        },
        toolTips: {
          disconnected: {
            title: "No se pudo iniciar la sesión de WhatsApp",
            content:
              "Asegúrese de que su teléfono celular esté conectado a Internet y vuelva a intentarlo o solicite un nuevo código QR",
          },
          qrcode: {
            title: "Esperando la lectura del código QR",
            content:
              "Haga clic en el botón 'CÓDIGO QR' y lea el Código QR con su teléfono celular para iniciar la sesión",
          },
          connected: {
            title: "Conexión establecida",
          },
          timeout: {
            title: "Se perdió la conexión con el teléfono celular",
            content:
              "Asegúrese de que su teléfono celular esté conectado a Internet y que WhatsApp esté abierto, o haga clic en el botón 'Desconectar' para obtener un nuevo código QR",
          },
        },
        table: {
          name: "Nombre",
          status: "Estado",
          lastUpdate: "Última Actualización",
          default: "Por Defecto",
          actions: "Acciones",
          session: "Sesión",
        },
        testBadge: "PRUEBA",
      },
      emptyState: {
        noResults: {
          title: "Nada encontrado",
          message: "Intenta buscar con otro término.",
        },
        connections: {
          title: "Conecta tu WhatsApp",
          message:
            "Conecta un número de WhatsApp para empezar a recibir los mensajes de tus clientes.",
          action: "Conectar WhatsApp",
        },
        contacts: {
          title: "Aún no hay contactos",
          message:
            "Los contactos aparecen aquí automáticamente cuando los clientes te escriben — o agrega uno manualmente.",
          action: "Agregar contacto",
        },
        queues: {
          title: "Organiza tu atención en colas",
          message:
            "Las colas dirigen a cada cliente al sector correcto, como Ventas o Soporte.",
          action: "Crear cola",
        },
        quickAnswers: {
          title: "Crea respuestas rápidas",
          message:
            "Guarda atajos para los mensajes que más envías y agiliza la atención.",
          action: "Crear respuesta rápida",
        },
        users: {
          title: "Agrega tu equipo",
          message:
            "Registra a los agentes que atenderán a los clientes de tu empresa.",
          action: "Agregar usuario",
        },
      },
      whatsappModal: {
        title: {
          add: "Agrega WhatsApp",
          edit: "Edita WhatsApp",
        },
        form: {
          name: "Nombre",
          default: "Por Defecto",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "WhatsApp guardado satisfactoriamente.",
      },
      qrCode: {
        message: "Lée el código QR para empezar la sesión.",
      },
      contacts: {
        title: "Contactos",
        toasts: {
          deleted: "¡Contacto borrado satisfactoriamente!",
        },
        searchPlaceholder: "Buscar...",
        confirmationModal: {
          deleteTitle: "Borrar",
          importTitlte: "Importar contactos",
          deleteMessage:
            "¿Estás seguro que deseas borrar este contacto? Todos los tickets relacionados se perderán.",
          importMessage:
            "¿Quieres importar todos los contactos desde tu teléfono?",
        },
        buttons: {
          import: "Importar Contactos",
          add: "Agregar Contacto",
        },
        table: {
          name: "Nombre",
          whatsapp: "WhatsApp",
          email: "Correo Electrónico",
          actions: "Acciones",
        },
      },
      contactModal: {
        title: {
          add: "Agregar contacto",
          edit: "Editar contacto",
        },
        form: {
          mainInfo: "Detalles del contacto",
          extraInfo: "Información adicional",
          name: "Nombre",
          number: "Número de Whatsapp",
          email: "Correo Electrónico",
          extraName: "Nombre del Campo",
          extraValue: "Valor",
        },
        buttons: {
          addExtraInfo: "Agregar información",
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Contacto guardado satisfactoriamente.",
      },
      quickAnswersModal: {
        title: {
          add: "Agregar respuesta rápida",
          edit: "Editar respuesta rápida",
        },
        form: {
          shortcut: "Atajo",
          message: "Respuesta rápida",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Respuesta rápida guardada correctamente.",
      },
      queueModal: {
        title: {
          add: "Agregar cola",
          edit: "Editar cola",
        },
        form: {
          name: "Nombre",
          color: "Color",
          greetingMessage: "Mensaje de saludo",
        },
        buttons: {
          okAdd: "Añadir",
          okEdit: "Ahorrar",
          cancel: "Cancelar",
        },
      },
      userModal: {
        title: {
          add: "Agregar usuario",
          edit: "Editar usuario",
        },
        form: {
          name: "Nombre",
          email: "Correo Electrónico",
          password: "Contraseña",
          profile: "Perfil",
          whatsapp: "Conexión estándar",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Usuario guardado satisfactoriamente.",
      },
      chat: {
        noTicketMessage: "Selecciona un ticket para empezar a chatear.",
      },
      ticketsManager: {
        buttons: {
          newTicket: "Nuevo",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Linhas",
      },
      tickets: {
        toasts: {
          deleted: "El ticket en el que estabas ha sido borrado.",
        },
        notification: {
          message: "Mensaje de",
        },
        tabs: {
          open: { title: "Bandeja" },
          closed: { title: "Resueltos" },
          search: { title: "Buscar" },
        },
        search: {
          placeholder: "Buscar tickets y mensajes.",
        },
        buttons: {
          showAll: "Todo el equipo",
          showAllTooltip:
            "Activado: muestra las atenciones de todos los agentes. Desactivado: muestra solo las tuyas.",
        },
      },
      testMode: {
        title: "Modo Prueba",
        config: {
          title: "Configuración de la prueba",
          subtitle:
            "Simula una conversación de cliente sin usar un WhatsApp real.",
        },
        connection: {
          label: "Conexión de prueba",
          createButton: "Crear conexión de prueba",
          emptyTitle: "Ninguna conexión de prueba",
          emptyDescription:
            "Crea una conexión de prueba para empezar a simular conversaciones.",
        },
        dialog: {
          title: "Nueva conexión de prueba",
          description:
            "La conexión de prueba nace ya conectada y sirve solo para simulaciones — no se usa ningún WhatsApp real.",
          nameLabel: "Nombre de la conexión",
          defaultName: "Conexión de Prueba",
          cancel: "Cancelar",
          create: "Crear",
        },
        client: {
          sectionTitle: "Cliente simulado",
          nameLabel: "Nombre del cliente",
          numberLabel: "Número del cliente",
          numberHelper: "Solo números, con código de país y de área.",
          defaultName: "Cliente de Prueba",
          newClientButton: "Nuevo cliente",
        },
        steps: {
          title: "Cómo funciona",
          step1: "Elige (o crea) una conexión de prueba.",
          step2:
            "Envía un mensaje como si fueras el cliente, usando el teléfono al lado.",
          step3:
            "Mira el ticket llegar en Atenciones y responde allí — la respuesta aparece en la pantalla del teléfono.",
        },
        phone: {
          chip: "MODO PRUEBA",
          online: "en línea",
          noConnection: "Sin conexión",
          inputPlaceholder: "Escribe un mensaje",
          emptyTitle: "Aún no hay mensajes",
          emptyDescription: "Envía el primer mensaje para iniciar la simulación.",
          emptyNoConnection: "Ninguna conexión seleccionada",
          emptyNoConnectionHint:
            "Elige o crea una conexión de prueba para comenzar.",
        },
        toasts: {
          connectionCreated: "¡Conexión de prueba creada con éxito!",
          selectConnection: "Selecciona una conexión de prueba antes de enviar.",
          invalidNumber: "Ingresa un número válido para el cliente simulado.",
        },
      },
      flydeskDevices: {
        title: "Computadoras (Flydesk)",
        searchPlaceholder: "Buscar por nombre, ID, empresa...",
        refresh: "Actualizar",
        hint: "Cada computadora aparece aquí después de que alguien inicia sesión en Flydesk en ella. Bloquear quita el acceso sin borrar el registro; eliminar libera una licencia.",
        empty: "Aún no hay computadoras registradas.",
        emptyHint:
          "Instala Flydesk en la computadora e inicia sesión con el acceso de la empresa — aparece aquí sola.",
        noResults: "Ninguna computadora coincide con esa búsqueda.",
        noDevicesInCompany: "Esta empresa aún no registró ninguna computadora.",
        online: "En línea",
        offline: "Desconectada",
        blocked: "Bloqueada",
        unnamed: "Sin nombre",
        never: "Nunca",
        justNow: "ahora mismo",
        minutesAgo: "hace {{m}} min",
        hoursAgo: "hace {{h}} h",
        daysAgo: "hace {{d}} días",
        licences: "licencias",
        unlimited: "Ilimitado",
        deviceCount: "{{n}} computadora(s)",
        onlineCount: "{{n}} en línea",
        copyId: "Clic para copiar el ID",
        idCopied: "¡ID copiado!",
        blockedHelper: "Bloquear impide que esta computadora inicie sesión",
        stats: {
          total: "Computadoras",
          online: "En línea ahora",
          companies: "Empresas",
          blocked: "Bloqueadas",
        },
        actions: {
          block: "Bloquear acceso",
          unblock: "Desbloquear",
          delete: "Eliminar computadora",
        },
        download: {
          title: "Instalar Flydesk en esta computadora",
          description:
            "Descárgalo e instálalo. Al abrirlo, inicia sesión con el mismo correo y contraseña que usas aquí — la computadora aparece en esta lista automáticamente.",
          button: "Descargar para Windows",
        },
        table: {
          name: "Nombre",
          deviceId: "ID",
          company: "Empresa",
          user: "Registrada por",
          status: "Estado",
          lastSeen: "Vista por última vez",
          blocked: "Bloqueada",
          actions: "Acciones",
        },
        confirmDelete: {
          title: "Eliminar computadora",
          message:
            "La computadora sale de la lista y libera una licencia. Si alguien inicia sesión en ella otra vez, vuelve a aparecer y consume licencia de nuevo.",
        },
        toasts: {
          updated: "Computadora actualizada.",
          deleted: "Computadora eliminada.",
        },
      },
      companies: {
        details: {
          modulesTitle: "Módulos contratados",
          limitsTitle: "Límites y uso",
          devicesTitle: "Computadoras en Flydesk",
          users: "Usuarios",
          connections: "Conexiones",
          devices: "PCs",
          unlimited: "sin límite",
          noDevices:
            "Ninguna computadora registrada. Instala Flydesk e inicia sesión con el acceso de esta empresa.",
          edit: "Editar empresa",
        },
        title: "Empresas",
        searchPlaceholder: "Buscar...",
        buttons: { add: "Agregar empresa", refresh: "Actualizar" },
        stats: {
          total: "Empresas",
          active: "Activas",
          users: "Usuarios",
        },
        table: {
          name: "Empresa",
          users: "Usuarios",
          createdAt: "Creada el",
          actions: "Acciones",
          default: "Predeterminada",
          status: "Estado",
          connections: "Conexiones",
          active: "Activa",
          inactive: "Inactiva",
          cannotDeleteDefault: "La empresa predeterminada no se puede eliminar",
          cannotDeactivateDefault:
            "La empresa predeterminada no se puede desactivar",
          empty: "No se encontraron empresas",
        },
        modal: {
          addTitle: "Nueva empresa",
          editTitle: "Editar empresa",
          name: "Nombre de la empresa",
          adminName: "Nombre del administrador",
          adminNameHelper: "Si está vacío, se usa el nombre de la empresa",
          email: "Correo de acceso",
          password: "Contraseña",
          cancel: "Cancelar",
          save: "Guardar",
          adminSection: "Administrador de la empresa",
          modulesSection: "Módulos contratados",
          moduleWhatsapp: "Atención WhatsApp",
          moduleWhatsappHelper: "Módulo base, incluido en todas las empresas",
          module_financeiro: "Financiero",
          module_flydesk: "Flydesk (acceso remoto)",
          limitsSection: "Límites (opcional)",
          maxDevices: "PCs en Flydesk",
          maxDevicesHelper: "Cuántos equipos puede registrar esta empresa. Vacío = ilimitado",
          maxUsersHelp:
            "Cuántas PERSONAS de esta empresa pueden acceder al sistema — cada agente con su propio correo y contraseña.\n\nEl administrador creado junto con la empresa ya cuenta. Ej.: límite 5 = admin + 4 agentes.\n\nAl alcanzar el límite, la empresa no puede crear nuevos usuarios. Los existentes siguen funcionando.",
          maxConnectionsHelp:
            "Cuántos NÚMEROS de WhatsApp puede conectar esta empresa (cada código QR leído es una conexión).\n\nLas conexiones del Modo Prueba no cuentan.\n\nAl alcanzar el límite, la empresa no puede agregar otro número. Los ya conectados siguen funcionando.",
          maxDevicesHelp:
            "Cuántas COMPUTADORAS puede registrar esta empresa en Flydesk para acceso remoto.\n\nLa PC cuenta cuando alguien inicia sesión en Flydesk en ella por primera vez. Al alcanzar el límite, el inicio de sesión es rechazado con aviso.\n\nEliminar una PC en la pantalla Acceso Remoto libera el lugar.",
          maxUsers: "Límite de usuarios",
          maxConnections: "Límite de conexiones",
          unlimitedHelper: "Vacío = ilimitado",
          status: "Empresa activa",
          validation: {
            required: "Obligatorio",
            tooShort: "Demasiado corto",
            tooLong: "Demasiado largo",
            invalidEmail: "Correo inválido",
            integer: "Use un número entero",
            limitMin: "Debe ser al menos 1",
          },
        },
        toasts: {
          saved: "Empresa guardada con éxito.",
          deleted: "Empresa eliminada con éxito.",
          activated: "Empresa activada.",
          deactivated: "Empresa desactivada.",
        },
        errors: {
          ERR_EMAIL_ALREADY_EXISTS: "Ya existe un usuario con este correo.",
          ERR_CANNOT_DEACTIVATE_DEFAULT_COMPANY:
            "La empresa predeterminada no se puede desactivar.",
          ERR_USER_LIMIT_REACHED:
            "Se alcanzó el límite de usuarios de la empresa.",
          ERR_CONNECTION_LIMIT_REACHED:
            "Se alcanzó el límite de conexiones de la empresa.",
          ERR_COMPANY_INACTIVE:
            "Esta empresa está inactiva. Contacte al administrador del sistema.",
        },
        confirmationModal: {
          deleteTitle: "Eliminar empresa",
          deleteMessage:
            "Esta acción borra TODOS los datos de la empresa: usuarios, conexiones, tickets y contactos. No se puede deshacer.",
        },
      },
      ticketsTeam: {
        hint: "Arrastra un ticket para transferirlo entre agentes o de vuelta a la cola.",
        you: "tú",
        waitingColumn: "Esperando",
        dropHere: "Suelta un ticket aquí",
        transferredTo: "Ticket transferido a",
        returnedToQueue: "Ticket devuelto a la cola",
        noQueue: "Sin cola",
      },
      transferTicketModal: {
        title: "Transferir Ticket",
        fieldLabel: "Escriba para buscar usuarios",
        fieldQueueLabel: "Transferir a la cola",
        fieldConnectionLabel: "Transferir to conexión",
        fieldQueuePlaceholder: "Seleccione una cola",
        fieldConnectionPlaceholder: "Seleccione una conexión",
        noOptions: "No se encontraron usuarios con ese nombre",
        buttons: {
          ok: "Transferir",
          cancel: "Cancelar",
        },
      },
      ticketsList: {
        pendingHeader: "Cola",
        assignedHeader: "Trabajando en",
        noTicketsTitle: "¡Nada acá!",
        connectionTitle: "Conexión que se está utilizando actualmente.",
        assignedTitle: "Agente responsable de esta atención.",
        groupMine: "Mis atenciones",
        groupTeam: "Equipo",
        noTicketsMessage:
          "No se encontraron tickets con este estado o término de búsqueda",
        buttons: {
          accept: "Acceptar",
        },
      },
      newTicketModal: {
        title: "Crear Ticket",
        fieldLabel: "Escribe para buscar un contacto",
        add: "Añadir",
        buttons: {
          ok: "Guardar",
          cancel: "Cancelar",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          connections: "Conexiones",
          tickets: "Tickets",
          contacts: "Contactos",
          quickAnswers: "Respuestas rápidas",
          financeiro: "Financiero",
          flydesk: "Acceso Remoto",
          queues: "Linhas",
          administration: "Administración",
          users: "Usuarios",
          settings: "Configuración",
          testMode: "Modo Prueba",
          superSection: "Plataforma",
          companies: "Empresas",
        },
        appBar: {
          user: {
            profile: "Perfil",
            logout: "Cerrar Sesión",
          },
        },
      },
      notifications: {
        noTickets: "Sin notificaciones.",
      },
      queues: {
        title: "Linhas",
        table: {
          name: "Nombre",
          color: "Color",
          greeting: "Mensaje de saludo",
          actions: "Comportamiento",
        },
        buttons: {
          add: "Agregar cola",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage:
            "¿Estás seguro? ¡Esta acción no se puede revertir! Los tickets en esa cola seguirán existiendo, pero ya no tendrán ninguna cola asignada.",
        },
      },
      queueSelect: {
        inputLabel: "Linhas",
      },
      quickAnswers: {
        title: "Respuestas rápidas",
        table: {
          shortcut: "Atajo",
          message: "Respuesta rápida",
          actions: "Acciones",
        },
        buttons: {
          add: "Agregar respuesta rápida",
        },
        toasts: {
          deleted: "Respuesta rápida eliminada correctamente",
        },
        searchPlaceholder: "Buscar ...",
        confirmationModal: {
          deleteTitle:
            "¿Está seguro de que desea eliminar esta respuesta rápida?",
          deleteMessage: "Esta acción no se puede deshacer.",
        },
      },
      users: {
        title: "Usuarios",
        table: {
          name: "Nombre",
          email: "Correo Electrónico",
          profile: "Perfil",
          whatsapp: "Conexión estándar",
          actions: "Acciones",
        },
        buttons: {
          add: "Agregar usuario",
        },
        toasts: {
          deleted: "Usuario borrado satisfactoriamente.",
        },
        confirmationModal: {
          deleteTitle: "Borrar",
          deleteMessage:
            "Toda la información del usuario se perderá. Los tickets abiertos de los usuarios se moverán a la cola.",
        },
      },
      settings: {
        success: "Configuración guardada satisfactoriamente.",
        title: "Configuración",
        settings: {
          userCreation: {
            name: "Creación de usuarios",
            options: {
              enabled: "Habilitado",
              disabled: "Deshabilitado",
            },
          },
        },
        pix: {
          title: "Pix de la empresa",
          subtitle:
            "Registra la clave que los agentes envían en el chat con /pix o con el botón R$.",
          key: "Clave Pix",
          name: "Nombre del receptor",
          nameHelper: "Nombre que ve el cliente al pagar",
          city: "Ciudad",
          save: "Guardar Pix",
          saved: "Datos de Pix guardados con éxito.",
          keyTypes: {
            phone: "Celular",
            random: "Clave aleatoria",
          },
        },
      },
      pix: {
        buttonTooltip: "Enviar Pix (/pix)",
        keyTypes: {
          phone: "Celular",
          random: "Clave aleatoria",
        },
        dialog: {
          title: "Enviar clave Pix",
          copyKey: "Copiar clave Pix",
          copied: "¡Clave Pix copiada!",
          send: "Enviar",
          sent: "¡Clave Pix enviada!",
          cancel: "Cancelar",
          hint: "El cliente recibe esta tarjeta en WhatsApp con el botón de copiar.",
          notConfiguredTitle: "Pix aún no configurado",
          notConfiguredAdmin:
            "Registra la clave Pix de la empresa en Configuración para enviarla en el chat.",
          notConfiguredUser:
            "Pide al administrador registrar la clave Pix de la empresa en Configuración.",
          goToSettings: "Ir a Configuración",
        },
      },
      messagesList: {
        header: {
          assignedTo: "Asignado a:",
          buttons: {
            return: "Devolver",
            resolve: "Resolver",
            reopen: "Reabrir",
            accept: "Aceptar",
          },
        },
      },
      messagesInput: {
        placeholderOpen: "Escriba un mensaje o presione '' / '' para usar las respuestas rápidas registradas",
        placeholderClosed:
          "Vuelva a abrir o acepte este ticket para enviar un mensaje.",
        signMessage: "Firmar",
      },
      contactDrawer: {
        header: "Detalles del contacto",
        buttons: {
          edit: "Editar contacto",
        },
        extraInfo: "Otra información",
      },
      ticketOptionsMenu: {
        delete: "Borrar",
        transfer: "Transferir",
        confirmationModal: {
          title: "¿Borrar ticket #",
          titleFrom: "del contacto ",
          message:
            "¡Atención! Todos los mensajes Todos los mensajes relacionados con el ticket se perderán.",
        },
        buttons: {
          delete: "Borrar",
          cancel: "Cancelar",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancelar",
        },
      },
      messageOptionsMenu: {
        delete: "Borrar",
        reply: "Responder",
        confirmationModal: {
          title: "¿Borrar mensaje?",
          message: "Esta acción no puede ser revertida.",
        },
      },
      backendErrors: {
        ERR_NO_OTHER_WHATSAPP:
          "Debe haber al menos una conexión de WhatsApp predeterminada.",
        ERR_NO_DEF_WAPP_FOUND:
          "No se encontró WhatsApp predeterminado. Verifique la página de conexiones.",
        ERR_WAPP_NOT_INITIALIZED:
          "Esta sesión de WhatsApp no ​​está inicializada. Verifique la página de conexiones.",
        ERR_WAPP_CHECK_CONTACT:
          "No se pudo verificar el contacto de WhatsApp. Verifique la página de conexiones.",
        ERR_WAPP_INVALID_CONTACT: "Este no es un número de whatsapp válido.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "No se pudieron descargar los medios de WhatsApp. Verifique la página de conexiones.",
        ERR_INVALID_CREDENTIALS: "Error de autenticación. Vuelva a intentarlo.",
        ERR_SENDING_WAPP_MSG:
          "Error al enviar el mensaje de WhatsApp. Verifique la página de conexiones.",
        ERR_DELETE_WAPP_MSG: "No se pudo borrar el mensaje de WhatsApp.",
        ERR_OTHER_OPEN_TICKET: "Ya hay un ticket abierto para este contacto.",
        ERR_SESSION_EXPIRED: "Sesión caducada. Inicie sesión.",
        ERR_USER_CREATION_DISABLED:
          "La creación de usuarios fue deshabilitada por el administrador.",
        ERR_NO_PERMISSION: "No tienes permiso para acceder a este recurso.",
        ERR_DUPLICATED_CONTACT: "Ya existe un contacto con este número.",
        ERR_NO_SETTING_FOUND:
          "No se encontró ninguna configuración con este ID.",
        ERR_NO_CONTACT_FOUND: "No se encontró ningún contacto con este ID.",
        ERR_NO_TICKET_FOUND: "No se encontró ningún ticket con este ID.",
        ERR_NO_USER_FOUND: "No se encontró ningún usuario con este ID.",
        ERR_NO_WAPP_FOUND: "No se encontró WhatsApp con este ID.",
        ERR_CREATING_MESSAGE: "Error al crear el mensaje en la base de datos.",
        ERR_CREATING_TICKET: "Error al crear el ticket en la base de datos.",
        ERR_FETCH_WAPP_MSG:
          "Error al obtener el mensaje en WhtasApp, tal vez sea demasiado antiguo.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "Este color ya está en uso, elija otro.",
        ERR_WAPP_GREETING_REQUIRED:
          "El mensaje de saludo es obligatorio cuando hay más de una cola.",
      },
    },
  },
};

export { messages };
